<div>
  <ngx-spinner [fullScreen]="false" type="ball-pulse-sync" size="medium">
    <p class="loading">Loading...</p>
  </ngx-spinner>
  <div #editorContainer id='editor' class='monaco-editor' style="width:100%;height:1000px;"></div>
</div>
